import clone from 'clone';
import {objectAtPathReducer} from 'dts-react-common';

let reducers = {
	ACTION_TYPES: {
		// App
		EXAMPLE_ACTION: 'EXAMPLE_ACTION',
		UPDATE_DATA: 'UPDATE_DATA',
	}
};

/*
 !! make sure to always create a copy of state instead of manipulating state directly
 action = {
 type: constant action name (required),
 error: error information (optional),
 payload: data for action (optional),
 meta: what else could you possibly want? (optional)
 }
 */

/* -------------#### Example ####------------- */

reducers[reducers.ACTION_TYPES.EXAMPLE_ACTION] = (state, action) => {
	const result = clone(state);
	//do something
	return result;
};

/* ---- Generic Reducer --------------------------------------------------------------------------------------
	payload single: {path: 'path.to.object', field: 'fieldInObject', value: 'new value of the field'}
	payload array: [ {path: 'path.to.object', field: 'fieldInObject', value: 'new value of the field'}, ... ]
   ----------------------------------------------------------------------------------------------------------- */
reducers[reducers.ACTION_TYPES.UPDATE_DATA] = objectAtPathReducer;

export default reducers;
